import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import * as AppActions from '@app/store/actions/app.actions';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { CoreService } from '@app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { SeoEventNames, SeoService } from '@app/modules/core/services/seo.service';
import { UserQrGeneratorService } from '@app/modules/user/services/user-qr-generator.service';
import { AlaCarteCheckoutSession, AlaCarteProductInterface, AlaCarteQrTypes, ProductPriceInterface, QrGeneratorNavigatorCategories, percentageCalculator } from 'shared-library';

@Component({
    selector: 'app-core-products-menu',
    templateUrl: './core-products-menu.component.html',
    styleUrls: ['./core-products-menu.component.scss']
})
export class CoreProductsMenuComponent implements OnInit, OnDestroy {

    session_info: SessionInfo
    appState$ = this.store.select(selectAppState);
    @Input() qr_category: QrGeneratorNavigatorCategories;

    selected_product: AlaCarteProductInterface;
    alacarte_session: AlaCarteCheckoutSession;
    products: Array<AlaCarteProductInterface> = []
    selected_product_price: ProductPriceInterface;
    private subscriptions: Subscription[] = []

    qr_categories: Record<AlaCarteQrTypes, AlaCarteQrTypes> = {
        memories: QrGeneratorNavigatorCategories.MEMORIES
    }

    cart_item = {
        quantity: 1
    }

    taking_email = false
    checkout_email = ""
    social_data: SocialHelper = {
        title: "",
        description: "",
        url: window.location.href,
        qr_url: window.location.href,
    };

    constructor(
        private store: Store,
        private router: Router,
        private seoService: SeoService,
        private cookieService: CookieService,
        public readonly coreService: CoreService,
        public readonly functionService: FunctionsService,
        public readonly qrGeneratorService: UserQrGeneratorService,
    ) {
        this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
        this.subscriptions.push(
            this.appState$.subscribe(ls => {
                this.products = ls.data.cache.products.alacarte.memories
                this.alacarte_session = ls.data.cache.alacarte_session
                if (this.products.length) {
                    if (!this.selected_product || !this.products.find(({ id }) => id === this.selected_product.id)) {
                        this.setSelectedProduct(this.products[0])
                    }
                } else if (this.selected_product) {
                    this.selected_product = null
                    this.selected_product_price = null
                }
            })
        )
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.subscriptions.map(sub => sub.unsubscribe())
    }

    priceDifference() {
        return (100 - percentageCalculator(this.selected_product_price.price, this.selected_product_price.old_price)).toFixed(2)
    }

    setSelectedProduct(product: AlaCarteProductInterface) {
        if (this.selected_product?.id === product.id) return
        this.selected_product = product
        this.social_data.title = this.selected_product.title
        this.social_data.description = this.selected_product.description
        if (this.selected_product.prices?.length) {
            if (!this.selected_product.prices.find(({ id }) => id === this.selected_product_price?.id)) {
                this.selected_product_price = this.selected_product.prices[0]
            }
        }
    }

    addToCart() {

        if (!this.alacarte_session || this.alacarte_session.paid) {

            if (!this.taking_email || (this.taking_email && !this.functionService.isEmail(this.checkout_email))) {
                this.taking_email = true
                return
            }

            this.taking_email = false
            // Initialize checkout session
            this.store.dispatch(AppActions.initialiseAlaCarteSession({
                data: {
                    email: this.checkout_email,
                    product_url: window.location.href,
                    quantity: this.cart_item.quantity,
                    product_id: this.selected_product.id,
                    product_title: this.selected_product.title,
                    product_price_id: this.selected_product_price.id,
                    product_description: this.selected_product_price.title,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    referral_id: this.cookieService.get(environment.referral_cookie_key),
                }
            }))

            // this.seoService.eventEmitter(SeoEventNames.UserActions, "addToCart", "sessionInitialise", {
            //   quantity: this.cart_item.quantity,
            //   product_url: window.location.href,
            //   product_id: this.selected_product.id,
            //   product_title: this.selected_product.title,
            //   product_price_id: this.selected_product_price.id,
            //   product_description: this.selected_product_price.title,
            //   timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            //   referral_id: this.cookieService.get(environment.referral_cookie_key),
            // })

            return
        }

        this.store.dispatch(AppActions.addToCartInAlaCarteSession({
            data: {
                id: "",
                quantity: this.cart_item.quantity,
                product_url: window.location.href,
                product_id: this.selected_product.id,
                product_title: this.selected_product.title,
                unit_price: this.selected_product_price.price,
                product_price_id: this.selected_product_price.id,
                product_description: this.selected_product_price.title,
            }
        }))

        // http://brandqrcodes.loc:4210/admin/checkout/sessions

        // this.seoService.eventEmitter(SeoEventNames.UserActions, "addToCart", "appendToSession", {
        //   quantity: this.cart_item.quantity,
        //   product_url: window.location.href,
        //   product_id: this.selected_product.id,
        //   product_title: this.selected_product.title,
        //   product_price_id: this.selected_product_price.id,
        //   product_description: this.selected_product_price.title,
        //   timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        //   referral_id: this.cookieService.get(environment.referral_cookie_key),
        // })

        this.router.navigateByUrl("/cart")
    }

}
